<template>
  <j-modal
    :class="'jee-outer-modal'"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :width="800"
    @cancel="handleCancel"
    @ok="handleSubmit"
    cancelText="关闭"
    style="top:20px;"
    title="修改"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="加水车辆">
          <j-dict-select-tag
            :dictCode="vehicleDictCode"
            :getPopupContainer="getParentModal"
            placeholder="请选择加水车辆"
            v-model="model.vehicleId"
          />
        </a-form-item>
        <a-form-item label="用水单位">
          <j-search-select-tag
            dict="`iwt-wf`.wf_consumer_corp_customer,customer_name,id, activated = 1 order by customer_name asc"
            placeholder="请选择用水单位"
            v-model="model.customerId"
          ></j-search-select-tag>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
  import { putAction } from '@/api/manage'

  export default {
    name: "WfconsumerRecordUsualModal",
    data () {
      return {
        visible: false,
        confirmLoading: false,

        model: {},
        url: {
          edit: "/wf/wfConsumerRecord/edit",
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form: this.$form.createForm(this)
      }
    },
    computed: {
      vehicleDictCode () {
        const corpId = this.model.corpId;
        let str = '`iwt-wf`.wf_consumer_corp_vehicle,vehicle_plate,id, vehicle_status = "operation"';
        if (corpId) {
          str += ` and corp_id = '${corpId}'`;
        }
        return str;
      }
    },
    methods: {
      show (record) {
        this.form.resetFields();
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(record));
        this.$nextTick(() => {
          this.form.setFieldsValue({ vehicleId: record.vehicleId });
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
      handleSubmit () {
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true;
            putAction(this.url.edit, {
              id: this.model.id,
              vehicleId: this.model.vehicleId || '',
              customerId: this.model.customerId || '',
            }).then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.$emit('ok');
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              this.confirmLoading = false;
              this.close();
            });
          }
        })
      },
      handleCancel () {
        this.close()
      },
      getParentModal () {
        return document.querySelector('.jee-outer-modal')
      }
    }
  }
</script>